import { render, staticRenderFns } from "./Switched.vue?vue&type=template&id=71f04d7d&"
import script from "./Switched.vue?vue&type=script&lang=ts&"
export * from "./Switched.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports